import * as React from 'react';
import * as Redux from 'redux';
import * as _ from 'lodash';
import { IState } from '../../reducers/index'
import { ISearchResult, IResults } from '../../state-helpers/search-results';
import { IPage } from '../../state-helpers/page';
import { ResultsCountMessage } from '../../../global/components/results/results-count-msg';

export interface ISearchResultsProps {
  totalResults: number;
  showingResults: ISearchResult[];
  pageModel: IPage;
  loading: boolean;
}

export class SearchResultsInfo extends React.Component<ISearchResultsProps, any> {
 
  render() {

    return (
      <div className="search-bar-info">
        <ResultsCountMessage
          totalResults={this.props.totalResults}
          pageResults={this.props.showingResults.length}
          pageSize={this.props.pageModel.pageSize}
          currentPage={this.props.pageModel.page}
          isLoading={this.props.loading}
          customClasses={"search-bar-subtext search-bar-info-total"}
        />
      </div>
    )
  }
};